<script lang="ts">
	import CameraTile from 'src/components/Camera/MonitoringDashboard/CameraTile.svelte';
	import type { Device } from 'src/types/Device';

	export let device: Device;
	export let liveFeed = false;
	export let allowFullscreen = false;
	export let denseOverlay = false;
	export let headerCompact = true;
	export let showNameOnHover = true;
</script>

<CameraTile
	camera={device}
	editMode={false}
	embedMode
	fillContainer
	showDashboardHeader
	hideHeaderActions={true}
	{liveFeed}
	{allowFullscreen}
	{headerCompact}
	{denseOverlay}
	{showNameOnHover}
	on:openDevice
/>
